import { render, staticRenderFns } from "./AlDropdownItem.vue?vue&type=template&id=52468db7&"
import script from "./AlDropdownItem.vue?vue&type=script&lang=js&"
export * from "./AlDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports